import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { SecurityKeyGuard } from './core/guards/security-key/security-key.guard';
import { LoginComponent } from './core/home/login/login.component';
import { LoadingPoSyncComponent } from './core/loading-po-sync/loading-po-sync.component';
import { IncorrectConfigurationComponent } from './core/errors/incorrect-configuration/incorrect-configuration.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./core/menu/menu.module').then(m => m.MenuModule)
  },
  { path: 'login', component: LoginComponent },
  { path: 'incorrect-configuration', component: IncorrectConfigurationComponent },
  { path: 'carga', component: LoadingPoSyncComponent, canActivate: [SecurityKeyGuard, AuthGuard] },
  { path: 'carga/reloadBranch/:company/:branch', component: LoadingPoSyncComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
